import { useEffect, useRef } from "react"
import { GeneralHeatmapRowProps } from "./GeneralheatmapRow.types"
import colormap from 'colormap'

const GeneralHeatmapRow = (props: GeneralHeatmapRowProps) => {

  const { heatmap, pixelHeight, width, colourPallate, range } = props
  const canvas = useRef<HTMLCanvasElement | null>(null)

  useEffect(() => {
    const colourMap = colormap({
        colormap: colourPallate,
        nshades: 255,
        format: "hex",
        alpha: 1
    })

    const sampleToHexColour = (sample: number): string => {
      // if (Math.ceil(sample) === 255) { return "#FFFFFF"}
      // Clamp x between 0 and 255
      const min = range === undefined ? Math.min(...heatmap[0]) : range.min
      const max = range === undefined ? Math.max(...heatmap[0]) : range.max
      const colour = Math.round(((sample - min) / (max - min)) * 255)
      const hexColor = colourMap[colour];
      return hexColor
    }

    const draw = (context: CanvasRenderingContext2D) => {
      if (canvas.current === null) { return }
      const pixelWidth = width / heatmap[0].length
      
      context.clearRect(0, 0, canvas.current.width, canvas.current.height)
      
      for (let column=0; column < heatmap.length; column++) {
        const scanRow = heatmap[column]
        const rowLength = scanRow.length
  
        for (let row=0; row<rowLength; row++) {
          context.fillStyle = sampleToHexColour(scanRow[row])
          context.fillRect(
            Math.floor(row * pixelWidth), 
            column * pixelHeight,
            Math.ceil(pixelWidth), 
            pixelHeight
          )
        }
      }
    }
    
    if (canvas?.current === null) { return }
    const context = canvas.current.getContext('2d', { willReadFrequently: true })

    if (context === null) { return }
    const min = Math.min(...heatmap[0])
    const max = Math.max(...heatmap[0]) 
    draw(context)
    
  }, [heatmap, pixelHeight, width, colourPallate, range])

  return (
    <div className="heatmap-row-container">
      <canvas
        className={`heatmap-row`}
        ref={canvas} 
        width={width}
        height={heatmap.length * pixelHeight}
      />
    </div>
  )
}

export default GeneralHeatmapRow